<template>
  <div class="container">

    <div class="wrapper">
      <div class="header">
        <h2>Ranking de Lojas{{ selectAno ? ' - ' + selectAno : '' }}</h2>
        <div class="options">
          <select
            v-model="selectAno"
            @change="handleSelectAno"
            >
            <option :value="null" disabled>Ano</option>
            <option v-for="(item, idx) in getAnos" :key="idx" :value="item.ano">{{ item.ano }}</option>
          </select>
        </div>
      </div>
      <loading v-if="getLoading" :items="15" />
      <div  v-else class="wrapper">
        <div class="table-responsive-vertical table-shadow">
          <!-- Table starts here -->
          <table class="table table-hover">
            <thead>
              <tr>
                <th width="30px">posi<br />ção</th>
                <th width="170px">loja</th>
                <th>receita<br />móvel</th>
                <th>receita<br />fixa</th>
                <th>receita<br />sva</th>
                <th>receita<br />terminais</th>
                <th>receita<br />total</th>
                <th width="55px">classifica<br />ção {{ getAno }}</th>
                <th width="45px">early<br />churn</th>
                <th width="55px">plus/<br />normal</th>
                <th width="60px">classifica<br />ção final</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="getData.length <= 0">
                <tr>
                  <td class="text-center" colspan="11">
                    NÃO EXISTE RANKING CADASTRADO PARA ESTE ANO.
                  </td>
              </tr>
              </template>
              <template v-else>
                <tr v-for="(item, idx) in getData" :key="idx">
                <td class="text-center" data-title="POSIÇÃO">
                  {{ item.posicao }}
                </td>
                <td data-title="LOJA">
                  <span
                    :class="
                      item.filial.nome === 'loja vivo'
                        ? 'text-blur'
                        : 'highlight'
                    "
                  >
                    {{ item.filial.nome | lojaPropria | uppercase }}
                  </span>
                </td>
                <td data-title="RECEITA MÓVEL" class="text-right">
                  {{ item.receita_movel | convertMoeda }}
                </td>
                <td data-title="RECEITA FIXA" class="text-right">
                  {{ item.receita_fixa | convertMoeda }}
                </td>
                <td data-title="RECEITA SVA" class="text-right">
                  {{ item.receita_sva | convertMoeda }}
                </td>
                <td data-title="RECEITA TERMINAIS" class="text-right">
                  {{ item.receita_terminais | convertMoeda }}
                </td>
                <td data-title="RECEITA TOTAL" class="text-right">
                  {{ item.receita_total | convertMoeda }}
                </td>
                <td data-title="CLASSIFICACAO 2020" class="text-center">
                  {{ item.classificacao | uppercase }}
                </td>
                <td data-title="EARLY CHURN" class="text-center">
                  {{ item.early }} %
                </td>
                <td data-title="PLUS/NORMAL" class="text-center">
                  {{ item.plus_normal | uppercase }}
                </td>
                <td data-title="CLASSIFICAÇÃO FINAL" class="text-center">
                  {{ item.classificacao_final | uppercase }}
                </td>
              </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env, { CANAL_PARCEIRO } from '@/config/env';
import { mapActions, mapGetters } from 'vuex';
import mixins from '@/helpers/mixins';
import RankingLoading from '@/components/Loading/RankingLoading';

export default {
  name: 'RankingLojas',
  mixins: [mixins],
  components: {
    loading: RankingLoading,
  },
  data: () => ({
    selectAno: null,
  }),
  computed: {
    ...mapGetters({
      getAno: 'rankingLoja/ano',
      getAnos: 'rankingLoja/anos',
      getLoading: 'rankingLoja/loading',
      getData: 'rankingLoja/data',
    }),
  },
  methods: {
    ...mapActions({
      setTitleBreadcrumb: 'breadcrumb/setTitleBreadcrumb',
      setRankingLojas: 'rankingLoja/getRankingLojas',
      setRankingLojasAno: 'rankingLoja/getRankingLojasAno',
      findRankingLojasAno: 'rankingLoja/findRankingLojasAno'
    }),
    handleSelectAno(evt) {
      const ano = evt.target.value;
      if (ano !== this.selectAno && ano !== '') {
        this.setRankingLojas({ ano })
      }
    }
  },
  filters: {
    lojaPropria: function(value) {
      if (value && value === 'loja vivo') {
        return 'loja vivo';
      }
      return value;
    },
  },
  async mounted() {
    // Redirect user not 5
    if (env.revista.canal === CANAL_PARCEIRO) {
      this.$router.push('/');
    }

    this.setTitleBreadcrumb({ name: 'Classificação das Lojas' });

    await this.setRankingLojasAno();

    this.selectAno = this.getAno;
  },
  beforeDestroy() {
    this.setTitleBreadcrumb({ name: null });
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.container {
  @extend %flex;
  @extend %direction-column;
  @extend %area-de-utilizacao;
  margin: 0 auto;
  position: relative;

  & .header {
    display: flex;
    @extend %direction-row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    & h2 {
      margin: 0;
      padding: 0;
      font-size: 32px;
      color: #609;
    }
    & .options {
      select {
        padding: 8px 12px;
        border-radius: 5px;
        border: none;
        color: #609;
        font-family: 'VivoType';
        &:focus {
          border: none;
        }
      }
      // visibility: hidden;
    }
  }

  & .wrapper {
    width: 100%;
    height: auto;
  }
}
// Variables
// ---------------------
$table-header-font-weight: 700;
$table-header-font-color: #222;

$table-cell-padding: 4px 8px;
$table-condensed-cell-padding: $table-cell-padding/2;

$table-bg: #fff;
$table-bg-accent: #f0f0f0;
$table-bg-hover: rgba(0, 0, 0, 0.12);
$table-bg-striped-hover: darken($table-bg-accent, 10%);
$table-td-color: #444;
$table-border-color: #e0e0e0;

@mixin table-shadow() {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12),
    0 1px 2px 0 rgba(0, 0, 0, 0.24);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12),
    0 1px 2px 0 rgba(0, 0, 0, 0.24);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 1px 2px 0 rgba(0, 0, 0, 0.24);
}
@mixin transition($transition) {
  -webkit-transition: $transition;
  -o-transition: $transition;
  transition: $transition;
}

// Helper
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-blur {
  user-select: none;
  color: transparent;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
}

.highlight {
  color: #660099;
  font-weight: bold;
}

.table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  max-width: 100%;
  margin-bottom: 2rem;
  background-color: $table-bg;
  font-family: 'OpenSans';
  > thead,
  > tbody,
  > tfoot {
    > tr {
      @include transition(all 0.3s ease);
      > th,
      > td {
        font-size: 11px;
        padding: $table-cell-padding;
        vertical-align: middle;
        border-top: 0;
        @include transition(all 0.3s ease);
        border-bottom: 1px solid #f0f0f0;
        height: 40px;
        letter-spacing: -0.1em;
        line-height: 1.2em;
        text-align: center;
      }
      > td {
        color: $table-td-color;
      }
      > th {
        background-color: $table-bg-accent;
        text-transform: uppercase;
        text-align: left;
        word-wrap: break-word;
        padding: $table-cell-padding;
        line-height: 1.2em;
      }
      > td:nth-child(2) {
        text-align: left !important;
      }
    }
  }
  > thead > tr > th {
    font-weight: $table-header-font-weight;
    color: $table-header-font-color;
    vertical-align: middle;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    text-align: center;
  }
  > thead > tr > th:nth-child(2) {
    text-align: left;
  }
  > caption + thead,
  > colgroup + thead,
  > thead:first-child {
    > tr:first-child {
      > th,
      > td {
        border-top: 0;
      }
    }
  }
  > tbody + tbody {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }

  // Nesting
  .table {
    background-color: $table-bg;
  }
}

.table-hover {
  > tbody > tr:hover {
    > td,
    > th {
      background-color: $table-bg-hover;
    }
  }
}

// Responsive (card)

.table-responsive-vertical {
  @media screen and (max-width: 1001px) {
    > .table {
      margin-bottom: 0;
      background-color: transparent;
      > thead,
      > tfoot {
        display: none;
      }

      > tbody {
        display: block;

        > tr {
          display: block;
          border: 1px solid $table-border-color !important;
          border-radius: 4px;
          padding: 1.6rem 0;
          margin-bottom: 1.6rem;
          > td {
            background-color: $table-bg;
            display: flex;
            padding: 0 1.6rem;
            justify-content: space-between;
            align-items: center;
            vertical-align: middle;
            text-align: right;
            border-bottom: 0;
          }
          > td[data-title]:before {
            content: attr(data-title);
            float: left;
            font-size: inherit;
            font-weight: $table-header-font-weight;
            color: $table-header-font-color;
          }
        }
      }
    }

    // Special overrides for shadows
    &.table-shadow {
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
      > .table > tbody > tr {
        border: none;
        @include table-shadow();
      }
    }

    // Special overrides for the bordered tables
    > .table-bordered {
      border: 0;

      // Nuke the appropriate borders so that the parent can handle them
      > tbody {
        > tr {
          > td {
            border: 0;
            border-bottom: 1px solid $table-border-color;
          }
          > td:last-child {
            border-bottom: 0;
          }
        }
      }
    }
    > .table-hover {
      > tbody {
        > tr:hover > td,
        > tr:hover {
          background-color: $table-bg;
        }
        > tr > td:hover {
          background-color: $table-bg-hover;
        }
      }
    }
  }
}

.table-hover > tbody > tr:hover > td,
.table-hover > tbody > tr:hover > th {
  background-color: $table-bg-hover;
}

@media screen and (max-width: 1000px) {
  .table-responsive-vertical .table-hover > tbody > tr:hover > td,
  .table-responsive-vertical .table-hover > tbody > tr:hover {
    background-color: $table-bg;
  }
  .table-responsive-vertical .table-hover > tbody > tr > td:hover {
    background-color: $table-bg-striped-hover;
  }
}
</style>
